/**
 * @file Default configuration for the application.
 */

export default {
  debug: process.env.REACT_APP_DEBUG === 'true',
  version: process.env.REACT_APP_VERSION,
};
